import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Modal, Select } from 'antd';
import InputMask from 'react-input-mask';
import styled, { css } from 'styled-components';
import { NewBookText } from '../pages/NewApplicationPage/components/BookRegistrationComponent/styled';
import {
  CustomBlueFormProps,
  CustomButtonProps,
  CustomColProps,
  FormLayoutProps,
  FormItemProps,
  RadioInfoProps,
  AppearBlockProps,
  CheckboxProps,
  FormContainerProps,
  CustomInfoLayoutProps,
  CloseButtonProps,
  CustomTextProps,
  BlueLayoutProps,
  DownloadColProps,
  FormInputProps,
  TabsContainerProps,
  ColoredSmallTextProps,
  GridItemProps,
  CustomSelectProps,
  ComponentsContainerProps,
  TableTypes,
  CustomModalTypes,
  ValidatorFormItemProps,
} from './types';

export const FormBlock = styled.div<CustomBlueFormProps>`
  display: ${(props) => {
    if (props.none) {
      return 'none';
    } else {
      return 'flex';
    }
  }};
  width: 100%;
  padding: ${(props) => (props.padding ? props.padding : '20px')};
  background: ${(props) => (props.white ? 'white' : props.background ? props.background : '#e9eef4')};
  border-radius: ${(props) => (props.noBorderRadius ? 'none' : '8px')};
  flex-wrap: nowrap;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
  position: ${(props) => (props.position ? props.position : 'static')};
  margin-top: ${(props) => (props.margintop ? props.margintop : 0)};

  .react-pdf__Page__textContent {
    display: none;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .upside-layout {
    font-size: 20px;
    line-height: 23px;
    color: rgba(56, 72, 91, 0.8);
    margin-bottom: 23px;
  }

  .to-center {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const FormInput = styled(Input)<FormInputProps>`
  padding: 5px 10px;
  font-size: 15px;
  border-radius: 5px;
  border: 1px solid ${(props) => (props.error ? 'red' : '#dceefc')};
  width: ${(props) => (props.width ? props.width : '100%')};
  margin-bottom: ${(props) => (props.mBottom ? props.mBottom : 'none')};
  margin-top: ${(props) => (props.mTop ? props.mTop : 'none')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  position: relative;
`;

export const FormNumberInput = styled(InputNumber)<FormInputProps>`
  font-size: 15px;
  border-radius: 5px;
  padding: 2.5px 0;

  border: 1px solid ${(props) => (props.error ? 'red' : '#dceefc')};
  width: ${(props) => (props.width ? props.width : '100%')};
  margin-bottom: ${(props) => (props.mBottom ? props.mBottom : 'none')};
  margin-top: ${(props) => (props.mTop ? props.mTop : 'none')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  position: relative;
`;

export const CustomMaskInput = styled(InputMask)<FormInputProps>`
  padding: 5px 10px;
  font-size: 15px;
  border-radius: 5px;
  border: 1px solid ${(props) => (props.error ? 'red' : '#dceefc')};
  width: ${(props) => (props.width ? props.width : '100%')};
  margin-bottom: ${(props) => (props.mBottom ? props.mBottom : 'none')};
  margin-top: ${(props) => (props.mTop ? props.mTop : 'none')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  position: relative;

  &:focus {
    outline: none;
  }
`;

export const CustomNumberInput = styled(InputNumber)<FormInputProps>`
  padding: 2.5px 10px;
  font-size: 15px;
  border-radius: 5px;
  border: 1px solid ${(props) => (props.error ? 'red' : '#dceefc')};
  width: ${(props) => (props.width ? props.width : '100%')};
  margin-bottom: ${(props) => (props.mBottom ? props.mBottom : 'none')};
  margin-top: ${(props) => (props.mTop ? props.mTop : 'none')};
  height: ${(props) => (props.height ? props.height : 'auto')};

  .ant-input-number-input {
    padding: 0;
    margin: 0;
  }
`;

export const CustomSelect = styled(Select)<CustomSelectProps>`
  width: ${(props) => (props.width ? props.width : '100%')};

  .ant-select-selection-overflow {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    gap: 5px;
  }

  .ant-select-selector {
    font-size: 15px !important;
    border-radius: 5px !important;
    border: 1px solid #dceefc !important;
    height: 35.5px !important;
    padding-top: 2px !important;
  }

  .ant-select-selection-overflow-item {
    width: auto !important;
  }

  .ant-select-selection-search,
  .ant-select-selection-item {
    width: auto !important;
    margin: 0 !important;
    overflow-x: hidden;
  }
`;

export const CustomDatePicker = styled(DatePicker)`
  padding: 5px;
  font-size: 15px;
  border-radius: 5px;
  border: 1px solid #dceefc;
  width: 100%;
`;

export const FormItem = styled(Form.Item)<FormItemProps>`
  width: ${(props) => (props.width ? props.width : '100%')};
  height: 100%;
  margin: ${(props) => (props.margin ? props.margin : '0')};
  padding: ${(props) => (props.padding ? props.padding : '0')};
  position: relative;

  .no-padding {
    padding: 0 !important;
  }

  .one-line-elements {
    display: flex;

    flex-direction: row;
    flex-wrap: nowrap;
    gap: 10px;
  }

  .ant-form-item-label {
    display: none;
  }

  .ant-form-item-required {
    display: none;
  }

  textarea {
    border-radius: 5px;
    border-color: #dceefc;
  }

  p {
    height: 25px;
  }

  .dark-text {
    font-size: 16px;
    color: rgba(56, 72, 91, 0.8);
  }

  &::before {
    content: '*';
    position: absolute;
    font-size: 18px;
    left: -10px;
    top: -6px;
    color: red;
    display: ${(props) => (props.redstar ? 'block' : 'none')};
  }

  .ant-select-selection-overflow-item,
  .ant-select-selection-overflow-item-rest .ant-select-selection-item {
    width: auto !important;
  }

  .ant-select-selection-overflow {
    display: flex;
    gap: 5px;

    * {
      flex: none;
      width: 100%;
    }
  }

  .izd-class {
    .ant-select-selection-item {
      width: 20px !important;
      text-overflow: ellipsis;
    }
  }

  .ant-form-item-control-input-content {
    gap: ${(props) => (props.gap ? props.gap : '10px')};
  }

  .row {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: flex-start;
  }

  .to-center {
    display: flex;
    justify-content: center;
    padding: 10px 0;
  }

  p,
  .text {
    color: #7594b9;
    margin: 0;
    font-size: 16px;
  }
`;

type ExpertiseResultsContainerProps = {
  display: boolean;
};

export const ExpertiseResultsContainer = styled.div<ExpertiseResultsContainerProps>`
  display: ${(props) => (props.display ? 'flex' : 'none')};
  flex-direction: column;
`;

export const ValidatorFormItem = styled(FormItem)<ValidatorFormItemProps>`
  flex-direction: row !important;
  width: ${(props) => props.width};

  input {
    background: ${(props) => (props.validator || props.overLength) && '#ffccc7'};
    border-color: ${(props) => (props.validator || props.overLength) && '#ff7875'};
  }

  //

  ${(props) =>
    props.overLength &&
    css`
      &:after {
        display: block;
        content: 'Превышено количество допустимых символов';
      }
    `}

  ${(props) =>
    props.validator &&
    !props.overLength &&
    css`
      &:after {
        display: block;
        content: 'Поле заполнено неверно';
      }
    `}

  &:after {
    color: red;
    font-size: ${(props) => (props.width ? '10px' : '14px')};
    z-index: 100;
    transition: all 2s;
  }
`;

export const FlexEndCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

export const ManualContainer = styled.div`
  max-width: 150px;
`;

export const CustomButton = styled.button<CustomButtonProps>`
  display: ${(props) => {
    if (props.flex) {
      return 'flex';
    } else if (props.none) {
      return 'none';
    } else {
      return 'block';
    }
  }};
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;

  gap: ${(props) => (props.gap ? props.gap : '10px')};
  max-width: ${(props) => (props.width ? props.width : '150px')};
  text-transform: ${(props) => (props.lowercase ? 'normal' : 'uppercase')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  padding: ${(props) => (props.padding ? props.padding : '8px 30px')};
  border-radius: 5px;
  margin-bottom: ${(props) => (props.marginbottom ? props.marginbottom : '0')};
  color: ${(props) =>
    props.lined || props.nolines ? '#378dda' : props.error ? '#ff4d4f' : props.light ? '#1B5990' : 'white'} !important;
  border: 1px ${(props) => (props.error ? 'dashed' : props.nolines ? 'none' : 'solid')}
    ${(props) =>
      props.lined
        ? '#378dda'
        : props.error
        ? '#ff4d4f'
        : props.disable && 'gray'
        ? props.light
          ? '#CDE3F6'
          : ''
        : ''} !important;
  border-color: ${(props) => props.error && '#ff4d4f !important'};
  text-decoration: ${(props) => (props.nolines ? 'underline' : 'none')};
  font-size: ${(props) => (props.fontsize ? props.fontsize : '14px')};
  background: ${(props) =>
    props.lined || props.nolines ? 'none' : props.light ? '#CDE3F6' : props.disable ? 'gray' : '#378dda'};
  transition: all 0.2s;
  white-space: ${(props) => (props.nowrap ? 'nowrap' : 'wrap')};
  user-select: none;

  &:active {
    background-color: ${(props) => !props.disable && '#1587dd !important'};
  }

  .medium,
  .medium > svg {
    height: 20px;
    width: 20px;
  }

  .icon,
  .icon > svg {
    width: 15px;
    height: 15px;

    margin: 0;
    padding: 0;
  }

  ${(props: CustomButtonProps) =>
    props.lined &&
    css`
      svg {
        fill: ${() => (props.error ? '#ff4d4f' : '#378dda')} !important;
      }

      &:hover {
        svg {
          fill: white !important;
        }
      }
    `}

  ${(props) =>
    !props.nolines &&
    !props.disable &&
    css`
      &:active {
        background: red;
      }

      &:hover {
        background: ${() => (props.error ? '#ff4d4f' : '#1272ba')};
        color: white !important;
        transition: all 0.2s;

        svg {
          fill: white;
        }

        .remove-button {
          color: white !important;

          &:hover {
            color: white !important;
          }
        }
      }
    `}
`;

export const CustomTableContainer = styled.div<TableTypes>`
  display: flex;
  flex-direction: column;
  gap: 25px;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0;
  overflow-x: auto;

  .ant-table-cell {
    background: white;
  }

  .button-book {
    border: 0;
    padding: 0;
    background: none;
    text-align: start;
  }

  .no-button {
    border: 0;
    padding: 0;
    background: none;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .align-center {
    text-align: center;
  }

  .ant-table-row-expand-icon,
  .ant-table-row-expand-icon-collapsed {
    display: none !important;
  }

  .text-link {
    text-decoration: underline;
    cursor: pointer;
  }

  .pointer {
    cursor: pointer;
  }

  .dark {
    color: black;
    text-decoration: underline;
  }

  .to-center {
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      cursor: pointer;
    }
  }

  .non-expand {
    .ant-table-row-expand-icon {
      display: none;
    }
  }

  .ant-table-wrapper {
    width: 100%;
  }

  .ant-pagination-jump-prev {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-pagination-jump-next {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-pagination-item {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-table-content {
    * {
      color: rgba(56, 72, 91, 0.8);
      font-size: 12.5px;
      line-height: 13px;
    }
  }

  .table {
    overflow-x: auto;
    background: white;
    width: 100%;

    .status-icon {
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        height: 30px;
      }
    }

    .link {
      text-decoration: underline;
      cursor: pointer;
    }

    .ant-pagination-item {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .ant-pagination {
      padding-right: 20px;
    }
  }

  p {
    margin-bottom: 0;
  }

  .ant-table-cell button {
    border: 0;
    display: flex;
    align-items: center;
  }

  .underlined {
    text-decoration: underline;
  }

  .arrow {
    color: white;
    font-size: 16px;
  }

  .rotate {
    transform: rotate(90deg);
  }

  .ant-table-thead {
    .ant-table-cell {
      background: #9cabbd;
      color: white;
      font-weight: 400;
    }
  }
`;

export const CustomCol = styled(Col)<CustomColProps>`
  display: flex;
  justify-content: flex-start;
  flex-direction: ${(props) => props.flexdirection};
  align-items: ${(props) => (props.flexdirection === 'row' ? 'center' : 'flex-start')};
  gap: ${(props) => (props.flexdirection === 'row' ? '10px' : 0)};

  .text {
    color: rgba(56, 72, 91, 0.8);
    font-size: 14px;
  }

  h1 {
    font-size: 14px;
    width: 100px;
    line-height: 14px;
    font-weight: 600;
    color: #7594b9;
    margin: 0;
  }
`;

export const CustomCheckbox = styled(Checkbox)`
  width: auto;
  display: flex;
  height: 30px;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0;

  p {
    height: 18px;
    margin-bottom: 0;
  }

  .ant-checkbox-inner,
  .ant-checkbox-input {
    width: 20px;
    height: 20px;
    border: 1px solid #7594b9;
    background: none;
  }

  .ant-checkbox-checked {
    background: #509bdf;
  }

  * {
    color: #7594b9;
    font-size: 16px;
    user-select: none;
  }
`;

export const CustomCheckboxGroup = styled(Checkbox.Group)<CheckboxProps>`
  display: flex;
  justify-content: flex-start;
  flex-direction: ${(props) => (props.row ? 'row' : 'column')};

  .ant-checkbox-inner,
  .ant-checkbox-input {
    width: 20px;
    height: 20px;
    border: 1px solid #7594b9;
    background: none;
  }

  .ant-checkbox-checked {
    background: #509bdf;
  }

  span {
    color: #7594b9;
    font-size: 16px;
    user-select: none;
  }
`;

export const CustomFormLayout = styled.div<FormLayoutProps>`
  padding: ${(props) => (props.padding ? props.padding : '10px 0')};
  margin: 0;
  font-weight: ${(props) => (!props.type ? 400 : props.type === 'fat' ? 600 : 400)};
  font-size: ${(props) => (props.size ? props.size : '20px')};
  color: ${(props) => (props.color ? props.color : '#59718e')};
  position: relative;

  &::before {
    content: '*';
    position: absolute;
    font-size: 18px;
    left: -10px;
    top: 38px;
    color: red;
    display: ${(props) => (props.redStar ? 'block' : 'none')};
  }
`;

export const CustomInfoLayout = styled.div<CustomInfoLayoutProps>`
  padding-bottom: 10px;
  font-size: ${(props) => (props.size ? props.size : '16px')};
  color: ${(props) => (props.color === 'dark' ? '#1272BA' : props.color === 'light' ? '#7594b9' : '#7594b9')};
  font-weight: ${(props) => {
    switch (props.weight) {
      case 'fat':
        return '600';
      case 'light':
        return '400';
      case 'normal':
        return '500';
      default:
        return '400';
    }
  }};
`;

export const DownloadCol = styled(Col)<DownloadColProps>`
	display: ${(props) => (props.none ? 'none' : 'block')};
  color: #7594b9;
  padding-bottom: ${(props) => (props.paddingBottom ? `${props.paddingBottom}px` : 'none')};

  border-bottom: ${(props) => (props.noBorder ? 'none' : '0.2px solid #cbd7e5')};


  .download-el {
    font-size: 12px;
    color: #606C7C;
    text-decoration: underline;
    border: 0;
  }


  .red-star {
    position: relative;

    &::before {
      content: '*';
      position: absolute;
      font-size: 18px;
      left: -10px;
      top: -3px;
      color: red;
    }
  }

  .padded {
    padding-top: 15px;
  }

  .margined {
    margin-bottom: 0;
  }

  .remove-button {
    height: 25px;
    width: 25px;


    background: none;
    color: #1272BA;
    font-weight: 300;
    font-size: 25px;
    transform: rotate(45deg);


    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    user-select: none;


    &:hover {
      color: #107CCD;

    }
  }

  .download-layout {
    white-space: nowrap;

    overflow: hidden;
    text-overflow: ellipsis;

    display: flex;
    align-items: center;
    justify-content: center;

  }

  .error-layout {
    color: #ff4d4f;
  }

  .plus {
    font-weight: 500;
  }

}

.error-uploader {

  .ant-upload-select {
    border-color: #ff4d4f !important;

    &:hover {
      background: #ff4d4f !important;

      * {
        color: white !important;
      }
    }
  }
}

.ant-upload-picture-card-wrapper,
.avatar-uploader {

  display: flex;
  justify-content: center;
  align-items: flex-end;


  .ant-upload {
    width: 100%;

    padding: 3px 5px;

    height: 100%;
  }


  .ant-upload-select {
    margin: 0;

    position: relative;

    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;

    background: none;
    transition: all 0.2s;
    border-radius: 5px;
    border: 1px solid #1272BA;


    .ant-upload {
      color: #1272BA;
      font-weight: 400;

      display: flex;
      flex-direction: row;
      gap: 15px;
    }

    svg {
      fill: #1064A3;
      margin: 0 !important;
      color: #1064A3;
    }

    &:hover {
      background: #1272BA;

      svg {
        fill: white;
        color: white;
      }


      .ant-upload {
        color: white;
      }
    }

    svg {
      margin-bottom: 10px;
    }


  }

  p {
    font-size: 13px;
  }

  svg {
    font-size: 35px;
    color: #7594b9;

    padding: 5px;
  }

  .download {
    text-decoration: underline;
  }
`;

export const CustomGoBackButton = styled.div`
  width: 40px;
  height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  background: none;
  border: 2px solid #1272ba;
  border-radius: 1000px;
  margin-bottom: 3px;

  color: #1272ba;
  font-size: 32px;
  font-weight: 400;
  user-select: none;

  transition: all 0.3s;

  &:hover {
    color: white;
    background: #1272ba;
    transition: all 0.3s;
  }

  &:active {
    color: white;
    background: #106aae;
    border: 3px solid #106aae;

    transition: all 0.3s;
  }
`;

export const BlueLayout = styled.div<BlueLayoutProps>`
  font-size: ${(props) => (props.fontsize ? props.fontsize : '30px')};
  text-transform: uppercase;
  line-height: 30px;
  padding: ${(props) => (props.padding ? props.padding : '20px 0')};
  font-weight: ${(props) => (props.weight ? props.weight : '600')};
  color: #1064a3;

  .go-back {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
  }

  display: flex;
  justify-content: flex-start;
  align-items: center;

  gap: 20px;
`;

export const RadioInfoBlock = styled.div<RadioInfoProps>`
  height: auto;
  width: 100%;

  position: relative;

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 5px;

  * {
    font-size: 16px;
    color: #7594b9;
  }

  &::before {
    content: '*';
    position: absolute;
    font-size: 18px;
    left: -10px;
    color: red;
    top: -3px;
    display: ${(props) => (props.redStar ? 'block' : 'none')};
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #7594b9 !important;
  }

  .ant-radio-checked .ant-radio-inner:after {
    background-color: #7594b9;
  }
`;

export const CustomBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 20px;
`;

export const AppearBlock = styled.div<AppearBlockProps>`
  width: 100%;
  padding: ${(props) => (props.padding ? props.padding : '20px')};
  background: #eff6fc;
  border-top: solid 20px white;
  position: relative;
`;

export const PagesContainerUI = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 25px;

  .ant-form-item-label {
    display: none;
  }
`;

export const TabsContainer = styled.div<TabsContainerProps>`
  width: 100%;
  padding: 0;
  position: relative;

  .reset-password {
    font-size: 14px;
    color: red;
    background: none;

    text-align: end;

    border: 0;

    position: absolute;
    top: 10px;
    right: 0;
    z-index: 50;

    &:hover {
      color: #ec0303;
    }

    &:focus {
      outline: none;
    }
  }

  .ant-tabs-tabpane,
  .ant-tabs-tabpane-active {
    padding: 0;
  }

  .ant-tabs-card .ant-tabs-content {
    margin-top: -16px;
  }

  .ant-tabs-card {
    border: none;
  }

  .ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane {
    background: #fff;
  }

  .ant-tabs-card > .ant-tabs-nav::before {
    display: none;
  }

  .ant-tabs-card .ant-tabs-tab-active {
    background: #fff;
    border: none;
  }

  .ant-tabs-card .ant-tabs-tab {
    background: transparent;
    border: none;

    font-size: 18px;
    color: #378dda;
  }

  .ant-tabs-tab .ant-tabs-tab-active {
    color: red !important;
  }

  .code-box-demo {
    padding: 24px;
    overflow: hidden;

    background: #f5f5f5;
  }

  .ant-tabs-card .ant-tabs-content > .ant-tabs-tabpane {
    background: none;
  }

  .ant-tabs-card .ant-tabs-tab-active {
    background: ${(props) => (props.white ? '#fff' : '#e9eef4')};
    font-weight: 400;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => (props.white ? '#378dda' : '#1890ff')};
  }
`;

export const FormContainer = styled.div<FormContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.columns ? 'row' : 'column')};
  padding: ${(props) => (props.padding ? props.padding : 0)};
  flex-wrap: wrap;
  gap: 15px;
  background: ${(props) => (props.background ? props.background : 'none')};

  .column-block {
    flex: 1;
  }

  .scrolled {
    height: 600px;
    overflow-y: scroll;
  }

  .clickable-svg {
    border: none;
    background: none;

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
  }

  .ant-form-item-required {
    display: none;
  }

  .gray-block {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 20px;
    background: #f3f3f3;

    .text {
      color: #686f75;
      font-weight: 400;
    }
  }

  .numeration,
  .dark-blue {
    font-size: 15px;
    font-weight: 400;
  }

  .dark-blue {
    color: rgba(56, 72, 91, 0.8);
  }

  .svg-icons {
    display: flex;
    gap: 10px;

    a,
    svg {
      height: 30px;
      cursor: pointer;
    }
  }

  .bottom-line {
    border-bottom: 1px solid #d6dde6;
  }

  .right-side-block {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .center,
  .right {
    width: 100%;

    display: flex;
    align-items: center;
    gap: 20px;
  }

  .center {
    justify-content: center;
  }

  .right {
    justify-content: flex-end;
  }

  .text,
  .big-text {
    color: #7594b9;
  }

  .text {
    font-size: 14px;
  }

  .big-text {
    font-size: 18px;
  }

  .padding-top-20px {
    padding-top: 20px;
  }

  .red-star {
    position: relative;

    &::before {
      content: '*';
      position: absolute;
      font-size: 18px;
      left: -10px;
      top: -3px;
      color: red;
    }
  }
`;

export const CollapseButton = styled.div`
  border-radius: 1000px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border: 1px solid #378dda;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    fill: #378dda;
    width: 15px;
    margin-top: 3px;
  }

  &:hover {
    background: #378dda;

    color: white;

    svg {
      fill: white;
    }
  }

  &:active {
    background: #2a77bc;
  }

  img {
    display: block;
    width: 15px;
  }
`;

export const CloseButton = styled(CollapseButton)<CloseButtonProps>`
  transform: rotate(45deg);
  color: #378dda;
  font-size: 25px;
  font-weight: 300;
  user-select: none;
  cursor: pointer;
  position: ${(props) => (props.positioned ? 'absolute' : 'none')};

  top: ${(props) => (props.pressed ? '5px' : '10px')};
  right: ${(props) => (props.pressed ? '0' : '10px')};
  z-index: 50;
`;

export const FileHolderBlock = styled.div`
  width: 100px;
  height: 100px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  padding: 5px;
  position: relative;

  border: 1px dashed #7594b9;
  background: #fafafa;

  svg {
    font-size: 20px;
    margin-bottom: 10px;
  }
`;

export const TableIconBlock = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;

  gap: 10px;

  cursor: pointer;

  svg {
    width: 30px;
    height: 30px;
  }

  .column-open {
    font-size: 20px;
    color: #9cabbd;

    font-weight: 400;
  }

  .rotate {
    transform: rotate(90deg);
  }
`;

export const ExpandedInfoContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .talal {
    padding: 0 !important;
  }

  gap: 5px;

  * {
    user-select: none;
  }

  .columns,
  .rows {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;

    * {
      flex: 1;
    }
  }

  .column {
    background: #ebf1fa;

    font-weight: 600;
  }

  .row,
  .column {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #606d7c;
    padding: 10px;
    gap: 15px;

    * {
      flex: none;
    }

    svg {
      height: 25px;
      font-size: 20px;
      margin-right: 10px;
    }
  }

  .row {
    font-weight: 400;
    background: #f4f9ff;
    padding: 10px;

    height: 80px;

    display: flex;
    gap: 0;
    flex-wrap: wrap;

    .row-element {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const EmptyBlock = styled.div`
  width: 100%;
  display: block;
`;

export const ContactsBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0;
  flex-direction: column;

  .text {
    height: auto;
    width: 100%;
    text-align: center;
  }
`;

export const GraySubtitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: rgba(56, 72, 91, 0.8);
  margin-top: -20px;

  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const CustomText = styled.div<CustomTextProps>`
  font-size: ${(props) => (props.size ? props.size : '16px')};
  color: ${(props) => (props.color ? props.color : '#000')};
  font-weight: ${(props) => (props.weight ? props.weight : 400)};
`;

export const CustomTextContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  color: #7594b9;
  gap: 10px;
`;

export const CollapsibleTextContainer = styled(NewBookText)`
  padding: 10px 0;
  font-size: 18px;
  font-weight: 400;

  .fat-text {
    font-weight: 500;
    font-size: 22px;
  }
`;

export const FormsContainer = styled.div`
  width: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 25px;
`;

export const CustomColumn = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

export const SvgFormer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  gap: 5px;

  button {
    color: white;
  }

  svg {
    height: 30px;
  }
`;

export const ExpandText = styled.div`
  white-space: nowrap;
  font-size: 14px;
  color: black;
  cursor: pointer;
  user-select: none;
  flex-direction: column;
  position: relative;
  display: flex;
  gap: 10px;

  .text {
    text-decoration: underline;
  }

  .rotate {
    font-weight: 400;
    font-size: 14px;
    transform: rotate(90deg);
    text-decoration: none;
  }
`;

export const ExpertiseComponentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const PopupContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 500;
`;

export const PopupUI = styled.div`
  min-width: 650px;
  background: white;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;

  padding: 35px 50px;

  .ant-radio-checked .ant-radio-inner {
    border-color: rgba(56, 72, 91, 0.8) !important;
  }

  .ant-radio-checked .ant-radio-inner:after {
    background-color: rgba(56, 72, 91, 0.8);
  }

  .ant-radio:hover .ant-radio-inner {
    border-color: rgba(56, 72, 91, 0.8);
  }

  .ant-radio-group {
    * {
      color: rgba(56, 72, 91, 0.8);
      font-size: 15px;
    }
  }

  .ant-radio-checked {
    &::after {
      border-color: rgba(56, 72, 91, 0.8);
    }
  }

  z-index: 5000;

  textarea {
    height: 300px !important;

    font-size: 15px;
    padding: 15px;
  }
`;

export const CloseBackground = styled.div`
  width: 100vw;
  height: 100vh;
  background: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
`;

export const NoButtonContainer = styled.div`
  width: 100%;

  button {
    border: none;
    background: none;

    padding: 0;
    margin: 0;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .link {
    color: #378dda;
    text-decoration: underline;
  }
`;

export const ExpertNameLayout = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  gap: 15px;

  padding: 20px 0;
  font-size: 30px;
  color: #1272ba;
`;

export const ColoredSmallText = styled.div<ColoredSmallTextProps>`
  color: ${(props) => (props.color ? props.color : '#7594b9')};
  font-size: ${(props) => (props.size ? props.size : '15px')};
  text-decoration: ${(props) => (props.underline ? 'underline' : 'none')};

  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  a {
    color: ${(props) => (props.color ? props.color : '#7594b9')};
  }

  .circle {
    width: 5px;
    height: 5px;
    background-color: rgba(56, 72, 91, 0.8);
    border-radius: 1000px;
  }
`;

export const CustomLayout = styled.div`
  font-weight: 400;
  font-size: 26px;

  color: rgba(56, 72, 91, 0.8);
`;

export const GridItem = styled.div<GridItemProps>`
  display: flex;
  width: ${(props) => (props.width ? props.width : '100%')};
  justify-content: ${(props) => (props.justify ? props.justify : 'flex-start')};
  align-items: ${(props) => (props.align ? props.align : 'flex-end')};
  flex-wrap: ${(props) => (props.wrap ? props.wrap : 'wrap')};
  gap: ${(props) => (props.gap ? props.gap : '0')};
  cursor: ${(props) => (props.pointed ? 'pointer' : 'static')};
  padding: ${(props) => (props.padding ? props.padding : '0')};
  position: relative;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '0')};
  border-bottom: ${(props) => (props.bottomBordered ? '1px solid black' : '0')};
  padding-bottom: ${(props) => (props.bottomBordered ? '35px' : '0')};

  flex-direction: ${(props) => (props.direction ? props.direction : 'column')};

  .no_line {
    text-decoration: none !important;
  }

  .ant-checkbox-wrapper {
    margin: 0;
  }

  .modal-title {
    color: #1272ba;
    font-size: 22px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .pages-text {
    color: white;
    font-size: 20px;
    text-align: center;
    font-weight: 300;
  }

  .empty-button {
    background: none;
    border: none;
    text-align: start;
  }

  .no-wrap {
    white-space: nowrap;
  }

  .for-expert-layout {
    font-size: 20px;
    font-weight: 400;
    color: #1d2a3a;
    text-align: center;
  }

  ${(props) =>
    !props.noText &&
    css`
      .text {
        font-size: 16px;
        font-weight: 400;
        color: #7594b9;
      }
    `}
  .layout-text {
    font-size: 22px;
    padding-bottom: 10px;
  }

  &::before {
    content: '*';
    position: absolute;
    font-size: 18px;
    left: -8px;
    top: -3px;
    color: red;
    display: ${(props) => (props.redstar ? 'block' : 'none')};
  }
`;

export const OpenFileLink = styled.a`
  text-decoration: underline;
  color: #606d7c;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 80%;
    text-decoration: underline;

    color: #606d7c;
    transition: all 0.2s;
  }
`;

export const CustomBigLettersLink = styled.a`
  font-size: 20px;
  color: #698cb5;
  width: auto;
  font-weight: 400;
  text-transform: uppercase;
  text-decoration-line: none;
  border-bottom: 1px solid #698cb5;
  white-space: nowrap;

  &:hover {
    color: #698cb5;
    opacity: 0.9;
  }
`;

export const MainpageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1900px;
  margin: 0 auto;
`;

export const MainpageComponentContainer = styled.div<ComponentsContainerProps>`
  max-width: 1240px;
  width: 100%;
  padding: 10px;
  display: flex;
  gap: 10px;
  flex-direction: ${(props) => (props.direction ? props.direction : 'column')};
  justify-content: ${(props) => (props.justify ? props.justify : 'flex-start')};

  margin: 0 auto;

  .ant-input-number-handler-wrap {
    display: none;
  }
`;

export const NavbarTextLinkButton = styled.button`
  color: rgba(56, 72, 91, 0.8);
  font-size: 16px;
  font-weight: 400;
  background: none;
  text-decoration: none;
  border: 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const ErrorMessage = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #ff4d4f;
`;

export const TextLink = styled.button`
  font-size: 16px;
  font-weight: 400;
  background: none;
  border: none;
  color: ${(props) => (props.color ? props.color : '#1064a3')};
  padding: 0;
  text-decoration: underline;
  cursor: pointer;

  a {
    color: #38485bcc;
  }

  &:hover {
    text-decoration: none;
  }
`;

export const FileLinkLayout = styled.button`
  font-weight: 400;
  font-size: 16px;
  text-decoration-line: underline;
  padding: 0;
  text-align: start;
  background: none;
  border: none;

  color: #606d7c;
`;

export const FileLinkRemoveButton = styled.div`
  width: 16px;
  height: 16px;

  border: 1px solid #606d7c;
  color: #606d7c;
  font-size: 12px;

  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 1000px;
  cursor: pointer;
  transform: rotate(45deg);
  transition: all 0.3s;

  &:hover {
    background: #606d7c;
    color: white;
    transition: all 0.3s;
  }
`;

export const WarningNotification = styled.div`
  color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  .notify-item {
    color: red;
    font-weight: 600;
    font-size: 12px;

    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    line-height: 1px;

    height: 18px;
    width: 18px;

    border: 1.5px solid red;
    border-radius: 2000px;
  }
`;

export const CustomModal = styled(Modal)<CustomModalTypes>`
  border-radius: 110px;
  padding: 40px 10px;

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-title {
    color: #1272ba;
    font-size: 20px;
  }

  .ant-btn-default {
    display: ${(props) => (props.showCancelButton ? 'inline-block' : 'none')};
  }

  .big-text {
    color: #606d7c;
    font-size: 20px;
    text-align: center;
    width: 100%;
    padding: 10px 20px;
  }

  .text {
    width: 100%;
    display: block;
    font-size: 16.5px;
    padding: 0 15px;
    color: #06263d;
  }

  .ant-modal-header {
    border-radius: 10px;
  }
`;
